import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chat",
  templateUrl: "./med-icon-chat.component.html",
})
export class MedIconChatComponent extends SvgMixinComponent {}
